export class ApplicationRoutes {
  static login = '/';
  static profile = 'my-profile';
  static shipments = 'shipments';
}
